<template>
  <div class="container">
    <PublicHeader :totalName="$t('auth').title" />
    <!-- 初级认证 -->
    <div class="title">{{ $t('auth').base }}</div>
    <div class="info">
      <!-- 手机号 -->
      <div class="item">
        <div class="lable">{{ $t('register').PhoneNumber }}</div>
        <!-- <VueCountryIntl schema="popover" :listZIndex="10000" popoverClass="selectCountry_auth" :searchInputPlaceholder="$t('register').searchCountryMsg" @onChange="selectCountry" :disabled="BaseReadonlyFlag">
          <van-field v-model="nationality" readonly :placeholder="$t('auth').tipsgj" right-icon="arrow-down" @click="selectCountry" slot="reference">
          </van-field>
        </VueCountryIntl> -->
        <van-field v-model="nationality" :placeholder="$t('register').placeholder0" :readonly="BaseReadonlyFlag">
        </van-field>
      </div>
      <!-- 姓名 -->
      <div class="item">
        <div class="lable">{{ $t('auth').userName }}</div>
        <van-field v-model="realName" :placeholder="$t('auth').tips1" :readonly="BaseReadonlyFlag">
        </van-field>
      </div>
      <!-- 证件类型 -->
      <div class="item">
        <div class="lable">{{ $t('auth').cardType }}</div>
        <van-field v-model="cardTypeTxt" readonly right-icon="arrow-down" @click="showSelect">
        </van-field>
      </div>
      <PopupSelect :title="$t('auth').cardType" v-model="showPopover" :selectList="cardTypeActions" :selectedValue="cardType" :onSelect="onSelect" />
      <!-- 证件号 -->
      <div class="item">
        <div class="lable">{{ $t('auth').IDNumber }}</div>
        <van-field v-model="certificate" :placeholder="$t('auth').tips2" :readonly="BaseReadonlyFlag">
        </van-field>
      </div>
      <!-- 按钮 -->
      <van-button v-if="!BaseReadonlyFlag" block @click="handleSubBase">{{ $t('auth').btn
      }}</van-button>
      <div class="tips" v-if="BaseReadonlyFlag">{{ BaseAuditStatusMsg }}</div>
      <!-- <div class="upbtn" v-if="BaseReadonlyFlag" @click="handleUpBase">{{ $t('auth').upbtn }}</div> -->
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PublicHeader from '@/components/publicHeader'
import PopupSelect from '@/components/popupSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PublicHeader,
    PopupSelect,
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      ReadonlyFlag: false,//高级认证修改
      BaseReadonlyFlag: false,//初级认证修改
      showPopover: false,
      cardTypeActions: [
        { text: this.$t('auth').idCard, val: 1 },
        { text: this.$t('auth').passport, val: 2 },
        { text: this.$t('auth').driverlicense, val: 3 },
      ],
      cardType: 1,
      cardTypeTxt: this.$t('auth').idCard,
      realName: '',
      certificate: '',
      nationality: '',
      ObverseImage: '',
      ObverseImage2: '',
      auditStatus: '',
      AuditStatusMsg: '',
      BaseAuditStatusMsg: '',
    }
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    this.getMemberAuthInfo()
  },
  methods: {
    showSelect() {
      if (this.BaseReadonlyFlag) return;
      this.showPopover = true
    },
    //选择证件类型
    async onSelect(action) {
      this.cardType = action.val
      this.cardTypeTxt = action.text
    },
    // 获取认证信息
    async getMemberAuthInfo() {
      const res = await userApi.getMemberAuthInfo()
      const userInfo = res.auth
      if (userInfo.realName) {
        this.realName = userInfo.realName
        this.certificate = userInfo.certificate
        this.nationality = userInfo.nationality
        this.cardTypeTxt = userInfo.authenticationType == 1 ? this.$t('auth').idCard : userInfo.authenticationType == 2 ? this.$t('auth').passport : userInfo.authenticationType == 3 ? this.$t('auth').driverlicense : ''
      }
      if (userInfo.imgs) {
        this.ObverseImage = userInfo.imgs.split(',')[0]
        this.ObverseImage2 = userInfo.imgs.split(',')[1]
      }
      this.BaseAuditStatusMsg = userInfo.auditStatus == '3' ? this.$t('auth').success : userInfo.auditStatus == '5' ? this.$t('auth').fail : userInfo.auditStatus == '4' ? this.$t('auth').success : userInfo.auditStatus == '1' ? this.$t('auth').wait : userInfo.auditStatus == '2' ? this.$t('auth').success : ''
      this.AuditStatusMsg = userInfo.auditStatus == '3' ? this.$t('auth').wait : userInfo.auditStatus == '4' ? this.$t('auth').success : ''
      this.BaseReadonlyFlag = userInfo.auditStatus !== '0'
      this.ReadonlyFlag = userInfo.auditStatus == '2'
      this.auditStatus = userInfo.auditStatus
    },
    // 正面照
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.ObverseImage = res.fileName
    },
    // 背面照
    async justAfterRead2(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.ObverseImage2 = res.fileName
    },
    // 选择国家
    selectCountry(val) {
      if (val.name) {
        this.nationality = val.name
      }
      this.$nextTick(() => {
        const searchInput = document.querySelector(
          '.selectCountry_auth .search-input'
        )
        if (searchInput) {
          searchInput.style.width = '90%'
          searchInput.style.height = 'auto'
        }
      })
    },
    // 高级修改确认
    handleUp() {
      this.$dialog.confirm({
        title: this.$t('auth').upMsg,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.ReadonlyFlag = true
        })
    },
    // 提交高级认证
    async handleSubHigh() {
      if (!this.ObverseImage) {
        this.$toast({ message: this.$t('auth').tips3 })
        return false
      }
      if (!this.ObverseImage2) {
        this.$toast({ message: this.$t('auth').tips4 })
        return false
      }
      const form = {
        imgs: this.ObverseImage + ',' + this.ObverseImage2,
      }
      this.btnloading = true
      await userApi.highAuth(form)
      this.btnloading = false
      this.getMemberAuthInfo()
      this.$toast({ message: this.$t('auth').subMsg })
      this.$router.go(-1)
    },
    // 初级修改确认
    handleUpBase() {
      this.$dialog.confirm({
        title: this.$t('auth').upMsg,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.BaseReadonlyFlag = false
        })
    },
    // 提交初级认证
    async handleSubBase() {
      if (!this.realName.trim()) {
        this.$toast({ message: this.$t('auth').tips1 })
        return false
      }
      if (!this.certificate.trim()) {
        this.$toast({ message: this.$t('auth').tips2 })
        return false
      }
      if (!this.nationality.trim()) {
        this.$toast({ message: this.$t('register').placeholder0 })
        return false
      }
      const form = {
        realName: this.realName,
        certificate: this.certificate,
        nationality: this.nationality,
        authenticationType: this.cardType,
      }
      await userApi.baseAuth(form)
      this.getMemberAuthInfo()
      this.$toast({ message: this.$t('auth').success })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 60px;

  .title {
    margin: 0 15px;
    font-size: 16px;
    font-weight: bold;
    color: var(--text_color);
  }

  .info {
    padding: 20px 15px;

    .lable {
      font-size: 13px;
      color: var(--ntext_color);
      margin-bottom: 10px;
    }

    .selbtn {
      background: var(--background_color);
      padding: 0 15px 0 15px;
      border-radius: 10px;
      font-size: 13px;
      color: var(--text_color);
      height: 40px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
    }

    .up_img {
      width: 170px;
      height: 107px;
      border-radius: 10px;
      background: var(--background_color);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      img {
        width: 170px;
        height: 107px;
        border-radius: 10px;
      }
    }

    .tips {
      margin-top: 20px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      color: var(--text_color);
    }

    .upbtn {
      margin-top: 20px;
      text-align: center;
      font-size: 13px;
      color: var(--ntext_color);
    }
  }

  .line {
    margin-bottom: 20px;
    height: 7px;
    background: var(--info_color);
  }
}

.vue-country-popover-container {
  width: 100%;
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid var(--info_color);
}

::v-deep .van-button {
  margin-top: 30px;
  background: var(--text_color);
  height: 40px;
  border-radius: 20px;
  border: 0;
  font-size: 15px;
  color: var(--background_color);
}
</style>
